import { currencyData } from "../utils/constants";
import { getFromLocalStorage } from "../utils/localStorageUtils";
import ProductCard from "./common/ProductCard";

const SaleProductSliderList = ({ products }) => {
    let currency = getFromLocalStorage(currencyData);

    return (
        <>
            {products?.map((product, index) => (
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12" key={'sale-product-slider-list' + index}>
                    <ProductCard product={product} currency={currency} />
                </div>
            ))}
        </>
    );
};

export default SaleProductSliderList;
